import { HTTP as http } from '../../http'

const PREFIX = '/newsletter'

export default {
    ActionSaveSubscription: (data) => {
        return http.post(PREFIX+'/saveSubscription', data)
    }

}